<template>
<div class="card">
    <div class="card-header">
        <p class="card-header-title">Import Students/Users from excel (xlsx)</p>
    </div>
    <div class="card-content" v-show="step == 1">
        <div class="content">            
            <loading :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="true">
            </loading>                           
            <b-field class="file">                      
                <b-upload v-model="file">
                    <a class="button is-primary">
                        <i class='upload icon'></i>
                        <span>Import students/users from excel</span>
                    </a>
                </b-upload>
                <span class="file-name" v-if="file">{{ file.name }}</span>
                <button class='button is-info' v-on:click="uploadExcel()">
                    Upload now
                </button>
            </b-field>      
            <a class="button is-warning" v-on:click="downloadTemplate()">Download Excel (xlsx) template</a>                       
        </div>
    </div>
    <div class="card-content" v-show="step == 2">
        <div class="content">            
            <loading :active.sync="isLoading1" 
                :can-cancel="false" 
                :is-full-page="true">
            </loading>
            <table class="table">
                <thead>
                    <tr>
                    <th>Your field titles</th>
                    <th>Preview</th>
                    <th>Assign to field</th>
                    </tr>
                    <tr v-for="(dataPreview,index) in dataPreviewList" :key="dataPreview.headers">
                        <td>{{ dataPreview.headers }}</td>
                        <td>{{ dataPreview.sample }}</td>
                        <td>
                            <b-select :name="'selectedField' + index" v-model="systemField[index]" expanded>
                                <option value="1">First Name</option>
                                <option value="2">Last Name</option>
                                <option value="3">Matrix Number</option>
                                <option value="4">Father's Name</option>
                                <option value="5">Father's ID</option>
                                <option value="6">Mother's Name</option>
                                <option value="7">Mother's ID</option>
                                <option value="8">Contact Number</option>
                                <option value="-1">-Don't Import-</option>
                            </b-select>
                        </td>
                    </tr>
                    <tr><td></td><td></td><td>
                        <b-button type='is-info' v-on:click="goToStep3()" expanded>
                            Next
                        </b-button>
                    </td></tr>
                </thead>
            </table>
        </div>
    </div>
</div>


</template>

<script>
import axios from 'axios'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { ToastProgrammatic as Toast } from 'buefy'
const helper = require("../../../../config/helper")

export default {
    props: ['kelasID'],
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            isLoading1: false,
            input: {
                idType: 1,  //for father's ID
                firstName: '',
                lastName: '',
                father: '',
                fatherID: '',
                mother: '',
                motherID: '',
                contactNo1: '',
                isCreating: false
            },
            kelasList: [],
            result: "",
            file: null,
            step: 1,
            excelData: [],
            dataPreviewList: [],
            selectedField: [],
            systemField: []
        };
    },
    computed:{
    },
    created() {
    },
    methods: {
        uploadExcel(){
            let self = this
            console.log("Entering uploadExcel")

            if (this.file != null){

                var fileExtension = helper.getExtension(this.file.name)
                console.log("fileExtension: " + fileExtension)

                if (fileExtension != "xlsx"){
                    Toast.open({
                        message: "Sorry, you can only upload Excel (xlsx) file.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }

                var fileSize = this.file.size
                console.log("fileSize: " + fileSize)

                if (fileSize > 1000000){
                    Toast.open({
                        message: "Sorry, you can only upload file not more than 1MB.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }

                self.isLoading = true;

                let formData = new FormData();                
                formData.append('token', localStorage.getItem('jwtTokenV2'));
                formData.append('email', localStorage.getItem('email'));
                formData.append('file', this.file);

                axios.post(process.env.MY_URL + '/studentsV2/import',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(response => {
                    console.log('SUCCESS!!');
                    console.log("90 response.data")
                    console.log(response.data)
                    self.isLoading = false
                    if (response.data.success == true) {
                        self.dataPreviewList = response.data.dataPreviewList
                        self.excelData = response.data.excelData
                        self.step = 2

                        this.dataPreviewList.forEach((dataPreview, index) => {
                            this.$set(this.systemField, index, (index+1).toString())
                        })
                    } else {
                        Toast.open({
                            message: response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 10000
                        })
                        this.isLoading = false
                        console.log(response.data.msg)
                    }
                })
                .catch(e => {
                    console.log(e)
                    Toast.open({
                        message: e.response,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 10000
                    })
                    this.isLoading = false
                });

            }else{
                Toast.open({
                    message: "Please select the excel file you want to upload!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
                return false;
            }
        },
        goToStep3(){
            let self = this

            var isFirstNameSet = false
            var isLastNameSet = false
            var isMatrixNumberSet = false
            var isFatherSet = false
            var isFatherIDSet = false
            var isMotherSet = false
            var isMotherIDSet = false
            var isContactNumberSet = false
            var firstNameCount = 0
            var lastNameCount = 0
            var matrixNumberCount = 0
            var fatherCount = 0
            var fatherIDCount = 0
            var motherCount = 0
            var motherIDCount = 0
            var contactNumberCount = 0

            var assignedFields = []

            console.log("entering goToStep3")
            this.dataPreviewList.forEach((dataPreview, index) => {
               console.log("ye: ")
               console.log(this.systemField[index])

               assignedFields.push(this.systemField[index])

                if (this.systemField[index] == 1){
                   isFirstNameSet = true;
                   firstNameCount = firstNameCount + 1
                }
                if (this.systemField[index] == 2){
                   isLastNameSet = true;
                   lastNameCount = lastNameCount + 1
                }
                if (this.systemField[index] == 3){
                   isMatrixNumberSet = true;
                   matrixNumberCount = matrixNumberCount + 1
                }
                if (this.systemField[index] == 4){
                   isFatherSet = true;
                   fatherCount = fatherCount + 1
                }
                if (this.systemField[index] == 5){
                   isFatherIDSet = true;
                   fatherIDCount = fatherIDCount + 1
                }
                if (this.systemField[index] == 6){
                   isMotherSet = true;
                   motherCount = motherCount + 1
                }
                if (this.systemField[index] == 7){
                   isMotherIDSet = true;
                   motherIDCount = motherIDCount + 1
                }
                if (this.systemField[index] == 8){
                   isContactNumberSet = true;
                   contactNumberCount = contactNumberCount + 1
                }
            })

            console.log("firstNameCount: " + firstNameCount)
            console.log("lastNameCount: " + lastNameCount)
            console.log("matrixNumberCount: " + matrixNumberCount)
            console.log("fatherCount: " + fatherCount)
            console.log("fatherIDCount: " + fatherIDCount)
            console.log("motherCount: " + motherCount)
            console.log("motherIDCount: " + motherIDCount)
            console.log("contactNumberCount: " + contactNumberCount)

            if (firstNameCount < 1){
                Toast.open({
                    message: "You need to at least assign the first name field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (firstNameCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the first name field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (lastNameCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the last name field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (matrixNumberCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the matrix number field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (fatherCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the father's name field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (fatherIDCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the father's ID field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (motherCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the mother's name field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (motherIDCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the mother's ID field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (contactNumberCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the contact number field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            console.log("311 Everything ok?")
            console.log("312 excelData.length: " + self.excelData.length)
            console.log(self.excelData[0].length)
            console.log(self.excelData[0])
            console.log("312 imini")
            console.log(self.excelData)
            console.log("312 assignedFields.length: " + assignedFields.length)
            console.log(assignedFields)

            //now let's replace the header (first) row
            for (var i = 0; i < self.excelData[0].length; i++){
                var j = i + 1;
                self.excelData[0][i] = assignedFields[i] + ""
            }
            console.log(self.excelData[0].length)
            console.log(self.excelData[0])
            
                
            self.isLoading = true;
           
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/studentsV2/import2', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                kelasID: self.kelasID,
                excelData: self.excelData,
                assignedFields: assignedFields
            })
            .then(response => {
                console.log("331 response.data.length: " + response.data.length)
                console.log("366: ")
                // console.log(response.data)
                // console.log(response.data.duplicatedStudentsLength)
                this.file = null
                self.isLoading = false
                
                if (response.data.duplicatedStudentsLength > 0){
                        
                    alert(response.data.msg)
                    
                    localStorage.setItem('duplicatedStudentList',JSON.stringify(response.data.duplicatedStudents))
                    localStorage.setItem('importToKelasId',this.kelasID)
                    this.$router.push({
                        name: "ManageStudentsImportDuplicate"
                    });

                }else{
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 10000
                    })
                }
                
                this.step = 1
                this.$parent.getStudentsInThisClass()

            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
        downloadTemplate(){
            var downloadLink = "https://" + window.location.hostname + "/downloads/template_students.xlsx";
            window.open(downloadLink,"_blank")
        },
        isSelected(index,number){
            console.log("entering isSelected with index: " + index + " and number: " + number)
            if (index == number){
                console.log("return true")
                return "true"
            }else{
                console.log("return false")
                return "false"
            }
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Manage/Students/ImportStudents.vue